<script setup lang="ts">
import { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger } from 'reka-ui'
import BButton from './bButton.vue';

const open = defineModel<boolean>('open');

const props = withDefaults(defineProps<{
  removeTrigger?: boolean
}>(), {
  removeTrigger: false
})

</script>

<template>
  <CollapsibleRoot v-model:open="open">
    <CollapsibleTrigger class="w-full flex justify-end" v-if="!removeTrigger">
      <slot name="trigger" >
        <BButton>
          Open
        </BButton>
      </slot>
    </CollapsibleTrigger>
    <CollapsibleContent class="CollapsibleContent">
      <slot></slot>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>


<style>

.CollapsibleContent {
  overflow: hidden;
}
.CollapsibleContent[data-state="open"] {
  animation: slideDown 300ms ease-out;
}
.CollapsibleContent[data-state="closed"] {
  animation: slideUp 300ms ease-out;
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: var(--reka-collapsible-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--reka-collapsible-content-height);
  }
  to {
    height: 0;
  }
}

</style>
